export default "__VITE_ASSET__DPZfNvHm__"